import React, { useRef, useState } from 'react';
import { Checkbox, FormControlLabel, FormHelperText, FormControl, useTheme } from '@mui/material';
import { Controller } from 'react-hook-form';
import { generateTestId } from 'app/functions';
import HtmlContent from 'components/html/HtmlContent';

export const HotCheckbox = ({
  name,
  control,
  label,
  required = false,
  helperText,
  linksNotClickedErrorText: _linksNotClickedErrorText,
  rules = {},
  sx,
  testID,
  ...rest
}) => {
  const htmlContentRef = useRef();
  const [fieldError, setFieldError] = useState('');
  const theme = useTheme();

  if (required && !rules.required) {
    rules.required = 'This field is required';
  }

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { value, onChange, ...field }, fieldState: { error } }) => (
        <React.Fragment>
        <FormControl error={!!fieldError || !!error} required={required}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "left",
            flexDirection: "row",
          }}
        >
          <FormControlLabel
            sx={sx}
            control={
              <Checkbox
                testid={generateTestId(testID, `${name}-checkbox`)}
                checked={!!value}
                onChange={(e) => {
                  onChange(e.target.checked);
                  setFieldError('');
                }}
                {...field}
                {...rest}
              />
            }
          />
          <HtmlContent 
                className='hot-checkbox-label'
                ref={htmlContentRef}
                content={label || ''}
                onClick={(e) => {
                  e.stopPropagation();
                }}
              />
        </FormControl>
        <FormHelperText 
            sx={{
              marginTop: "-5px",
              minHeight: "1rem",
              color: theme.palette.text.error,
              fontSize: "0.75rem",
              visibility: (!!error?.message || fieldError || helperText) ? 'visible' : 'hidden'
            }}
          >
            { fieldError || error?.message || helperText || ' ' }
          </FormHelperText>
        </React.Fragment>
      )}
    />
  );
};

export default HotCheckbox;
